export interface ApiResponse {
  success: boolean;
  error?: string;
}
export interface ApiDataResponse<T> extends ApiResponse {
  data: T;
}
export interface ReportGenerationApiResponse {
  FileName: string;
}
